import React from 'react'

const GiftVoucherIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M30.2395 15.218H1.75781V32H30.2395V15.218Z" fill="#BBF7D0" />
      <path d="M18.9561 15.218H13.0352V32H18.9561V15.218Z" fill="#4ADE80" />
      <path
        d="M16.2144 4.99041C16.2144 4.99041 13.6443 -1.52768 9.55563 0.334634C5.46696 2.19694 5.6345 8.26904 11.1277 7.87427C16.6208 7.47951 16.2144 4.99041 16.2144 4.99041Z"
        fill="#EF4444"
      />
      <path
        d="M16.6863 4.99041C16.6863 4.99041 19.26 -1.52768 23.3486 0.334634C27.4373 2.19694 27.2698 8.27205 21.7766 7.86825C16.2835 7.46445 16.6863 4.99041 16.6863 4.99041Z"
        fill="#EF4444"
      />
      <path
        d="M16.4523 7.31959C17.7852 7.31959 18.8656 6.4062 18.8656 5.27948C18.8656 4.15276 17.7852 3.23938 16.4523 3.23938C15.1195 3.23938 14.0391 4.15276 14.0391 5.27948C14.0391 6.4062 15.1195 7.31959 16.4523 7.31959Z"
        fill="#991B1B"
      />
      <path
        d="M30.1927 6.83167H1.80729C0.809149 6.83167 0 7.51569 0 8.35948V11.1891C0 12.0329 0.809149 12.7169 1.80729 12.7169H30.1927C31.1908 12.7169 32 12.0329 32 11.1891V8.35948C32 7.51569 31.1908 6.83167 30.1927 6.83167Z"
        fill="#BBF7D0"
      />
      <path d="M18.96 6.83167H13.0391V12.7169H18.96V6.83167Z" fill="#4ADE80" />
    </svg>
  )
}

export default React.memo(GiftVoucherIcon)
